/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import Layout from "../Component/Layout/Layout";

import ServiceHero from "../Component/Service/ServiceHero";
import Pakages from "../Component/Service/Pakages";
import Team from "../Component/Service/Team";
import Review from "../Component/Service/Review";
import AboutTimming from "../Component/Service/AboutTimming";
import Nearby from "../Component/Service/Nearby";
import { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { Loader } from "../Component/Loader/Loader";
import RainBackground from "../Component/ThreeJs/RainBackground";
import { axiosInstance } from "../utils/axiosInstance";
import { useSelector } from "react-redux";

const Services = () => {
  const params = useParams();
  console.log(localStorage.getItem("category"), "cate");

  const { ServicesNew } = useSelector((state) => state.auth);
  const { Provider } = useSelector((state) => state.auth);
  const { provider_category_detail } = Provider;
  console.log(provider_category_detail, "detail");
  const filter_category_id = provider_category_detail?.provider_category?.id;
  // const { SelectedService } = Provider?.provider_category_detail;
  // console.log(ServicesNew, "servicepage");

  const providerdata = useLocation();
  const { state } = providerdata.state || {};
  // console.log(state?.provider_category_profiles, "providerdara");
  const filterCategory =
    provider_category_detail?.provider_category_profiles?.filter((category) => {
      return category?.id === Number(params.id);
    });

  // console.log(filterCategory, "filter");
  const [service, setService] = useState([]);
  const [saloon, setsaloon] = useState({});

  const [loader, setLoader] = useState(false);

  const fetchProviderDetail = async () => {
    setLoader(true);
    await axiosInstance
      .get(`provider/${params.id ? params?.id : provider_category_detail?.id}`)
      .then((res) => {
        setService(
          res.data?.provider?.provider_category_profiles?.[0]
            ?.provider_category_services
        );
        setsaloon(res.data?.provider);
        setLoader(false);
      })
      .catch((err) => {
        // console.log(err);
      });
  };
  useEffect(() => {
    fetchProviderDetail();
  }, [params?.id]);

  console.log(service, "service");
  if (loader) {
    return <Loader />;
  }

  console.log(saloon,'outerpage')

  return (
    <>
      <div className="tt-magic-cursor">
        <RainBackground />
        <Layout>
            
            <ServiceHero saloon={saloon} providers={filterCategory} service={service} />
          <Pakages
            saloon={saloon}
            provider={filterCategory}
            service={service}
          />
          {/* <Team /> */}
          {/* <Review /> */}
          <AboutTimming  saloon={saloon} provider={filterCategory} />
          <Nearby filter_category_id={filter_category_id} id={filterCategory} />
          {/* <AboutSection />
          <HomeServices />
          <WhyChoose />
          <FactsSection />
          <PhotoGallery />
          <PricingSection />
          <GiftCard />
          <Testimonial />
          <LatestPost /> */}
        </Layout>
      </div>
    </>
  );
};

export default Services;
